/**
 * Переход из админки в ЛК ученика (B-2378).
 *
 * Ментор (и админ) может сам учиться на курсе. Кабинет по умолчанию уводит
 * ментора без лида обратно в админку (B-2175), поэтому ссылка несёт явный
 * признак `?as=student`: кабинет обменивает токен с `as_student`, бэкенд
 * заводит лид, и человек остаётся в кабинете. Сессию переносит общая
 * SSO-cookie `.drafter.ru` — токен в адресе не передаём.
 */

// Кабинет акселератора. Дефолт — прод, как у соседних VITE_* (см. Dockerfile):
// переменная доезжает в бандл только через build-arg.
const CABINET_URL: string =
  import.meta.env.VITE_CABINET_ACCELERATOR_URL || "https://cabinet.accelerator.drafter.ru";

export const STUDENT_CABINET_URL = `${CABINET_URL.replace(/\/+$/, "")}/login-required?as=student`;
